<script>
import ViewTitle from '@/components/ViewTitle'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import Button from '@/components/Button'
import LoyaltyCard from '@/components/LoyaltyCard'
import LoyaltyCardsService from '@/services/loyaltyCards'
import EnvironmentUtils from '@/utils/environmentUtils'

export default
{
    name: 'loyalty-card-edit-credit-points',

    render () 
    {
        return (
            <div id='loyalty-card-edit-credit-points-view'>
                <view-title>Créditer une carte</view-title>
                <loyalty-card card-id={this.cardId} />
                <floating-label-text-input placeholder='Nombre de points à créditer' type='number' v-model={this.pointsToCredit} autofocus={true} on-enter={this.confirmCredit} />
                <Button ref='nextBtn' text='Continuer' type='primary' on-click={this.confirmCredit} />
            </div>
        )
    },

    data () 
    {
        return {
            pointsToCredit: ''
        }
    },

    mounted ()
    {
    },

    computed: 
    {
        cardId ()
        {
            return this.$route.params.cardId;
        },

        storeId ()
        {
            return this.$route.params.storeId;
        }
    },

    methods:
    {
        async confirmCredit ()
        {
            this.$refs.nextBtn.showSpinnerWhile(async () =>
            {
                await LoyaltyCardsService.creditCard(EnvironmentUtils.cityId, this.$store.state.user.token, this.cardId, this.storeId, parseInt(this.pointsToCredit))
                this.$toast.success(`La carte ${this.cardId} a été créditée avec succès`)
                this.$router.push({ name: 'LoyaltyCardEdit' })
            })
        }
    },

    components:
    {
        ViewTitle,
        FloatingLabelTextInput,
        Button,
        LoyaltyCard
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#loyalty-card-edit-credit-points-view
{
    display: flex;
    flex-direction: column;
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);
    margin-left: 10px;
    margin-right: 10px;

    .OnTablet({
        margin-left: auto;
        margin-right: auto;
        max-width: 550px;
    });
    .OnDesktop({ margin-top: 8vh; });

    .floating-label-text-input
    {
        width: -webkit-fill-available;
    }

    .button
    {
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LoyaltyCardEditCreditPoints.vue